import type { LoginStep } from "@custos/api-client";
import { create } from "zustand";

/** The pending 2FA step after a correct admin password. Memory only. */
export interface Challenge {
  token: string;
  status: LoginStep["status"];
}

interface AuthState {
  status: "loading" | "anonymous" | "authenticated";
  challenge: Challenge | null;
  notice: string | null;
  setAuthenticated: () => void;
  setAnonymous: () => void;
  sessionExpired: () => void;
  setChallenge: (challenge: Challenge | null) => void;
  setNotice: (notice: string | null) => void;
}

export const useAuth = create<AuthState>((set) => ({
  status: "loading",
  challenge: null,
  notice: null,
  setAuthenticated: () => set({ status: "authenticated", challenge: null, notice: null }),
  setAnonymous: () => set({ status: "anonymous" }),
  sessionExpired: () =>
    set({
      status: "anonymous",
      notice: "Your admin session ended (12 hours, logout or IP change). Please log in again.",
    }),
  setChallenge: (challenge) => set({ challenge }),
  setNotice: (notice) => set({ notice }),
}));
